<div class="cache-stat-container">
    <div class="scale-container">
        <div style="width:200px">Datasets cached</div> <mat-progress-bar class="cache-bar" [color]="getColor()"
            [mode]="'determine'" [value]="getValue()">
        </mat-progress-bar><span class="scale-value">{{cacheStatistic?.cacheSize}}</span>
    </div>
    <div class="value-container">Min cache size: {{cacheStatistic?.minCacheSize}}</div>
    <div class="value-container">Max cache size: {{cacheStatistic?.maxCacheSize}}</div>
    <div class="value-container">Data availability <mat-icon [ngClass]="getStatusClass()"
            class="data-availability-mark">fiber_manual_record</mat-icon></div>
</div>